import { create } from "zustand"

import type { Role, RoleSortField, RolesListQuery, SortingOrder } from "@/graphql/codegen/graphql"
import { RolesListDocument } from "@/graphql/codegen/graphql"
import { type SearchFilters, createSearchStore } from "@/stores/createSearchStore"

export type RolesSearchFilters = SearchFilters & {
  field?: RoleSortField
  order?: SortingOrder
}

const deduplicateData = (newData: Role[], existingData: Role[]): Role[] => {
  const uniqueIds = new Set(existingData.map((role) => role.roleId))
  return [...existingData, ...newData.filter((role) => !uniqueIds.has(role.roleId))]
}

export const useRolesSearchStore = create(
  createSearchStore<Role, RolesSearchFilters, RolesListQuery>({
    documentNode: RolesListDocument,
    deduplicateData,
    getQueryInput: (filters: RolesSearchFilters) => {
      const { field, order } = filters
      return {
        sort: { field, order },
      }
    },
    getQueryVariables: (queryInput) => ({ input: queryInput }),
    extractDataFromResponse: (data) => ({
      __typename: data.role.list.__typename,
      data: data?.role.list.__typename === "RoleListSuccess" ? (data.role.list.roles as Role[]) : [],
      error: data?.role.list.__typename === "RoleFailure" ? data.role.list.error : undefined,
    }),
  })
)
